import React from 'react'
import styled from 'styled-components'

import { ReactComponent as DropDownSVG } from '../assets/images/dropdown.svg'

export const DropDownStyledSVG = styled<any & { selected: boolean }>(
  DropDownSVG
)`
  width: 0.5em;
  height: 0.5em;
  fill: ${({ theme, selected }) =>
    selected ? theme.dropdownSelectedColor : theme.dropdownNotSelectedColor};
  stroke: ${({ theme, selected }) =>
    selected ? theme.dropdownSelectedColor : theme.dropdownNotSelectedColor};
  align-self: center;
  vertical-align: center;
`
